export const order = {
  create: 'orderEndpoint/v2/createOrder',
  getOrders: 'orderEndpoint/v3/getOrders',
  getOrder: 'oms/v1/order/detail/:orderId',
  getTracking: 'orderEndpoint/v3/getTrackingOrder',
  getRatings: 'orderEndpoint/getRatings',
  rate: 'orderEndpoint/v3/qualifyService',
  reOrder: 'orderEndpoint/addDeliveryOrder',
  cancelOrder:'orderEndpoint/v3/cancelOrderCourierDataStore',
  orderUpdate:'orderEndpoint/order/orderUpdate/v3/pickingDate',
  updateUserPrime: 'oms/v1/order/prime',
  getListOrderCancellationReasonCustomer: 'monitor/v3/getListOrderCancellationReasonCustomer',
  getEstimatedTimeByDefault: 'oms/v1/estimatedTime/',
  getEstimatedTimeByIdAddress: 'oms/v1/estimatedTime/:idAddress',
  getEstimatedTimeByIdAddressAndOrderId: 'oms/v1/estimatedTime/:idAddress/:orderId',
  getActiveOrders: 'orderEndpoint/orders/active',
  getPreviousOrders: 'orderEndpoint/orders/previous',
  uploadPrescription: '/oms/v1/order/prescription',
  getDeliveryTypeTime: 'orderEndpoint/deliveryTypeTime',
};
